<div class="context-box p-3" (clickOutside)="closeModal()">
  <ng-content></ng-content>
</div>
